import Container from '@mui/material/Container';

export const SiteContent = ({ children, siteContentStyle, disableGutters }) => (
  <Container maxWidth="siteContainer" id="SiteContent" sx={siteContentStyle} disableGutters={disableGutters}>
    {children}
  </Container>
);
